import { ReactElement } from "react";
import { Stack } from "@twilio-paste/core/stack";

import { MessageBlockRole } from "@twiliointernal/e2-commons-shared-definitions";
import { useWiseOwlContext } from "../../../../hooks";
import { MessageSkeletonLoader } from "../../../../components/blockRenderer/sub";
import { AvatarWrapper } from "@twiliointernal/e2-commons-shared-ui";

const FetchChatLoader = (): ReactElement => {
  const { author } = useWiseOwlContext();

  return (
    <Stack orientation="vertical" spacing="space40">
      <AvatarWrapper role={MessageBlockRole.User} author={author}>
        <MessageSkeletonLoader />
      </AvatarWrapper>

      <AvatarWrapper role={MessageBlockRole.Assistant}>
        <MessageSkeletonLoader />
      </AvatarWrapper>
    </Stack>
  );
};

export default FetchChatLoader;
